import { useAtom } from 'jotai';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// libs
import { onlyUniqueCommentsOptions } from '@/lib/giveawayPicker/options';

// Components
import { Select } from '@/components/base/Select/SelectComponent';
// Atoms
import { optionsAtom } from '@/components/pages/giveaway-picker/Atoms/OptionsAtoms';
import { TitleOption } from '@/components/pages/giveaway-picker/OptionsWrapper/components/TitleOption';

const optionsOnlyUniqueComments = onlyUniqueCommentsOptions;

export const OnlyUniqueComments = () => {
    const { t } = useTranslation('giveaway_picker');
    const [options, setOptions] = useAtom(optionsAtom);

    return (
        <div className="flex flex-col gap-3">
            <TitleOption
                title={t('options.only_unique_comments')}
                subtitle={t('options.only_unique_comments_subtitle')}
            />
            <Select
                className="w-full"
                selected={optionsOnlyUniqueComments.find(
                    (option) => option.value === options.only_unique_comments
                )}
                setSelected={(option) =>
                    setOptions((prev) => ({
                        ...prev,
                        only_unique_comments: option.value
                    }))
                }
                options={optionsOnlyUniqueComments}
            />
        </div>
    );
};
